class Onboarding {
  constructor() {
    this.pages = [
      this.easyPayment(),
      this.attendance(),
      this.youSafe(),
    ];
  }

  easyPayment() {
    return this.buildPage(
      'payment',
      'Facilidade para pagamentos',
      `Com o Quero Pago você tem a liberdade de pagar a sua mensalidade do jeito
       que você preferir, seja em <b>cartão de crédito</b>, <b>cartão de débito</b> ou por <b>boleto</b>.
       Tudo isso clicando em um botão`,
    );
  }

  attendance() {
    return this.buildPage(
      'support',
      'Atendimento campeão',
      `Nosso time foi campeão brasileiro de atendimento em 2017. Aqui é tudo sem enrolação!
      Você consegue renegociar algum pagamento pelo seu próprio <b>Whatsapp</b>.`,
    );
  }

  youSafe() {
    return this.buildPage(
      'secure',
      'Você totalmente seguro',
      `O Quero Pago é um sistema totalmente seguro e criptografado, que conta com a
       <b>certificação HTTPS</b>, a mesma usada por diversos bancos e grandes lojas
       virtuais no mundo inteiro.`,
    );
  }

  buildPage(illustration, title, text) {
    return { illustration, title, text };
  }
}

export default Onboarding;
